import Rails from '@rails/ujs'

export function initRails(): void {
  try {
    Rails.start()
  } catch {
    // Rails UJS already started
  }
}
